import { render, staticRenderFns } from "./CertificateIndex.vue?vue&type=template&id=04de962e&scoped=true"
import script from "./CertificateIndex.vue?vue&type=script&lang=js"
export * from "./CertificateIndex.vue?vue&type=script&lang=js"
import style0 from "./CertificateIndex.vue?vue&type=style&index=0&id=04de962e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de962e",
  null
  
)

export default component.exports